"use client";

import { Spacer as HeroSpacer } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Spacer = ({ className, ...props }: { className?: string } & React.ComponentProps<typeof HeroSpacer>) => {
  return <HeroSpacer className={cn(className)} {...props} />;
};
